module.exports = __webpack_public_path__ + "media/kids.7a58e803.mp4";